<template>
  <button
    class="t-button"
    :class="[ `t-button--loading`, ...classes, {'t-button--is-loading': loading} ]"
    :type="nativeType"
    @click="handleClick"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <span class="t-button__loading-label">
      <span class="t-button__left" v-if="$slots.left"><slot name="left"></slot></span>
      <slot></slot>
      <span class="t-button__right" v-if="$slots.right"><slot name="right"></slot></span>
    </span>
    <span class="t-button__loading-spinner">
      <t-spinner color="#fff" :font-size="spinnerFontSize"/>
    </span>
  </button>
</template>

<script>
import ColorTypeMixin from '../../mixins/ColorTypeMixin';
import TButton from './TButton.vue';
import TSpinner from '../TSpinner';

export default {
  components: { TSpinner },
  extends: TButton,
  name: 't-button-loading',
  mixins: [ColorTypeMixin],
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    spinnerFontSize() {
      return this.small ? '1.5rem' : '2rem';
    },
  },
  methods: {
    handleClick(event) {
      if (this.loading) {
        event.preventDefault();
      }
    },
  },
};
</script>
